var exports = {
  "Hx": "Flash__bezM-h",
  "az": "Box__5Crrc8",
  "EY": "Text__9ZCxA8",
};

module.exports = exports;
